import _ from 'lodash'
import exportState from 'scoreboard/components/export/export-state'


/**
 * Returns an object containing state that should be applied to the current view.
 *
 * It is possible for a view to have persisted state.  During exports this state
 * is returned in the globals response.  But briefing slides and bookmarks save
 * any state in their url property, and it is passed to routers using
 * a `?state={jsonString}` param
 *
 * @param {String} [urlState] A JSON string that should be parsed
 */
function persistedViewState(urlState) {
	let state
	if (exportState.state && exportState.shouldApply) {
		// Exports provide state in globals.exportState
		state = exportState.state
	} else if (!_.isEmpty(urlState)) {
		// Bookmarks/briefings pass it as querystring param
		try {
			state = JSON.parse(urlState)
		} catch (e) {
			console.log('failed to parse urlState:', urlState)
		}
	}
	return state
}

export default persistedViewState
persistedViewState.__filename__ = 'components/persisted-view-state.js'
